export default "__VITE_ASSET__DTJkGHV4__"